import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';
import { Paper, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import Divider from "@mui/material/Divider";
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import DataTable from 'examples/Tables/DataTable';
import MDInput from "components/MDInput";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useLoading } from 'context/loading.context';
import { useMaterialUIController } from 'context';
import { getWhatsappContacts, SOCKET_SERVER_URL, getWhatsappChatToken } from 'network/service';
import { styled } from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import io from 'socket.io-client';
import Badge from '@mui/material/Badge';
import { getContacts } from 'network/service';
import ParcelHistory from './components/PackagesDetails';

const SentMessage = styled(Paper)(({ theme }) => ({
    backgroundColor: '#d1e7dd',
    color: '#0f5132',
    padding: theme.spacing(1),
    borderRadius: '10px',
    maxWidth: '60%',
    margin: theme.spacing(1),
    alignSelf: 'flex-start',
}));

const ReceivedMessage = styled(Paper)(({ theme }) => ({
    backgroundColor: '#f8d7da',
    color: '#842029',
    padding: theme.spacing(1),
    borderRadius: '10px',
    maxWidth: '60%',
    margin: theme.spacing(1),
    alignSelf: 'flex-end',
}));

const RetrieveMessageContent = ({ message }) => {
    let content = message.content;
    let message_temp = "";
    let icon = "check";
    let color = "grey";
    if (content.type === "template") {
        message_temp = "Template Message"
    }
    else if (content.type === "text") {
        message_temp = content.text.body;
    }

    if (message.message_status === "sent") {
        icon = "check"
    }
    else if (message.message_status === "delivered") {
        icon = "doneAll"
    }
    else if (message.message_status === "read") {
        icon = "doneAll"
        color = "blue"
    }
    return (<Grid container direction={"column"}>
        <Grid item>
            <MDTypography variant="body2">{message_temp}</MDTypography>
        </Grid>
        <Grid item>
            <Grid container justifyContent={"space-between"}>
                <Grid item>
                    <MDTypography variant="overline">{moment(message.timestamp).format("YYYY-MM-DD hh:mm")}</MDTypography>
                </Grid>
                <Grid item>
                    {(icon === "check") && <CheckIcon />}
                    {(icon === "doneAll") && <DoneAllIcon style={{ color: color }} />}
                </Grid>
            </Grid>
        </Grid>
    </Grid>)
}

const MessagingBubble = ({ message }) => {
    return (
        <Grid
            item
            container
            key={message.message_id}
            justifyContent={(message.message_direction === "down") ? 'flex-start' : 'flex-end'}
        >
            {(message.message_direction === "down") ? (
                <SentMessage>
                    <RetrieveMessageContent message={message} />
                </SentMessage>
            ) : (
                <ReceivedMessage>
                    <RetrieveMessageContent message={message} />
                </ReceivedMessage>
            )}
        </Grid>
    );
};


export default function WhatsappScreen() {

    const { showLoader, hideLoader } = useLoading();
    const [controller, dispatch] = useMaterialUIController();
    const { sidenavColor } = controller;
    const [contacts, setContacts] = useState([]);
    const [contactNames, setContactNames] = useState([]);
    const [chatOpen, setChatOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [selContact, setSelContact] = useState(null);
    const [socket, setSocket] = useState(null);
    const [token, setToken] = useState(null);
    const [chatmessages, setChatMessages] = useState({ messages: [], contents: {} });

    const [detailsdialog, setDetailsDialog] = useState({ open: false, details: null });

    const selContactRef = useRef(selContact);
    const chatMessagesRef = useRef(chatmessages);
    const scrollableRef = useRef(null);



    useEffect(() => {
        if (contacts.length > 0) {
            let params = ``;
            for (let cst of contacts) {
                if (params.length > 0) {
                    params += `&`
                }
                params += `phone_in=${cst.wa_id.slice(-10)}`;
            }
            getContacts(params).then((resp) => {
                let temp = {};
                for (let ts of resp.data) {
                    temp[ts.phone] = ts.name
                }
                setContactNames(temp);
            }).catch((err) => {
                console.log(err);
            })
        }
    }, [contacts])

    useEffect(() => {
        getWhatsappContacts().then((resp) => {
            setContacts(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setContacts]);

    useEffect(() => {
        selContactRef.current = selContact;
    }, [selContact]);

    useEffect(() => {
        chatMessagesRef.current = chatmessages;
    }, [chatmessages]);

    const checkAndAddNewMessage = (data) => {
        if (data.contact === selContact.wa_id) {
            let temp = [...chatmessages.messages];
            let contents = { ...chatmessages.contents };
            temp.push(data.message_id);
            contents[data.message_id] = { ...data };
            setChatMessages({ messages: temp, contents: contents });

        }
        else {
            getWhatsappContacts().then((resp) => {
                setContacts(resp.data);
            }).catch((err) => {
                console.log(err);
            })
        }
    }

    useEffect(() => {
        if (!chatOpen && token) {
            let socketConnection = io(SOCKET_SERVER_URL, {
                path: "/communication/socket.io",
                query: {
                    token: token,
                    type: "data-socket"
                }
            });

            socketConnection.on('connect', () => {
                console.log('Connected to server');
                setChatOpen(true);
            });

            socketConnection.on('disconnect', () => {
                console.log('Disconnected from server');
                setChatOpen(false);
            });

            socketConnection.on('all_messages', (data) => {
                console.log("All messages", data);
                let temp = [];
                let content = {};
                for (let msg of data) {
                    temp.push(msg.message_id);
                    content[msg.message_id] = { ...msg };
                }
                setChatMessages({ messages: temp.reverse(), contents: content });
            });
            socketConnection.on('new_message', (data) => {
                console.log("New messages", data, selContactRef.current);
                // checkAndAddNewMessage(data);
                if (data.contact === selContactRef.current?.wa_id) {
                    let temp = [...chatMessagesRef.current.messages];
                    let contents = { ...chatMessagesRef.current.contents };
                    temp.push(data.message_id);
                    contents[data.message_id] = { ...data };
                    setChatMessages({ messages: temp, contents: contents });

                }
                else {
                    getWhatsappContacts().then((resp) => {
                        setContacts(resp.data);
                    }).catch((err) => {
                        console.log(err);
                    })
                }
            });

            socketConnection.on('status_change', (data) => {
                console.log("Status Change", data);
                let temp = [...chatMessagesRef.current.messages];
                let contents = { ...chatMessagesRef.current.contents };
                let temp_2 = contents[data.id];
                console.log("Temp 2", temp_2);
                if (temp_2) {
                    temp_2['message_status'] = data['status'];
                    contents[data.id] = { ...temp_2 };
                    setChatMessages({ messages: temp, contents: contents });
                }

            });


            setSocket(socketConnection);
        }

        return () => {
            if (socket && socket.connected) {
                socket.disconnect();
            }
        };
    }, [setChatOpen, token]);

    useEffect(() => {
        if (scrollableRef.current) {
            scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
        }
    }, [chatmessages]);

    useEffect(() => {
        getWhatsappChatToken().then((resp) => {
            console.log(resp.data);
            setToken(resp.data.token);
        }).catch((err) => {
            console.log();
        })
    }, [setToken]);

    const sendMessage = () => {
        if (chatOpen && (message.length > 0)) {
            socket.emit('send_messages', { receiver: selContact.wa_id, message: message });
            setMessage("");
        }

    }

    const selectContact = (val) => {
        setSelContact(val);
        setChatMessages({ messages: [], contents: {} });
        socket.emit('get_messages', { contact: val.wa_id });
    }


    return (

        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <ParcelHistory isOpen={detailsdialog.open} details={detailsdialog.details} handleclose={() => { setDetailsDialog({ open: false, details: null }); }} />
                <Grid container spacing={6}>
                    <Grid item xl={4} md={12} xs={12}>
                        <Card sx={{ height: "79vh", padding: 2, overflow: 'auto' }}>
                            Contacts
                            <Divider style={{ margin: 0 }} />
                            {contacts.map((val, ind) => {
                                return (<><MDButton variant={(selContact?.wa_id === val.wa_id) ? "outlined" : "text"} color="info" onClick={() => { selectContact(val) }}>
                                    <Grid container sx={{ overflow: 'hidden', textOverflow: "ellipsis" }}>
                                        <Grid item xs={4} xl={4} md={4}>
                                            <Grid container
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{ height: "100%" }}>
                                                <Badge variant="dot" color="info" invisible={(val.unread_chat) ? false : true}><AccountCircleIcon fontSize="large" /></Badge>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={8} xl={8} md={8}>
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="flex-start"
                                                alignItems="flex-start"
                                            >
                                                <MDTypography variant="h6" sx={{
                                                    whiteSpace: "nowrap",       // Prevent text from wrapping
                                                    textOverflow: "ellipsis",   // Show ellipsis (...)
                                                }}>{contactNames[val.wa_id.slice(-10)] ?? val.wa_id}</MDTypography>
                                                <MDTypography variant="caption">{val.wa_id}</MDTypography>
                                            </Grid>
                                        </Grid>
                                    </Grid></MDButton>
                                    <Divider style={{ margin: 0 }} /></>)
                            })}
                        </Card>
                    </Grid>
                    <Grid item xl={8} md={12} xs={12}>
                        <Card sx={{ height: "69vh", overflow: 'auto' }} ref={scrollableRef}>
                            {!selContact && <Grid container sx={{ height: "100%" }} justifyContent={"center"} alignItems={"center"}>
                                <MDTypography>Choose a contact to see the messages</MDTypography>
                            </Grid>}
                            {selContact && chatOpen &&
                                <Grid container padding={2} sx={{ height: "100%" }}>
                                    <Grid item sx={{ flexGrow: 1, overflow: 'auto' }}>
                                        <Grid container direction="column">
                                            {chatmessages.messages.map((val, ind) => <MessagingBubble message={chatmessages.contents[val]} />)}
                                        </Grid>
                                    </Grid>
                                    {/* <Grid item alignSelf={"flex-end"} sx={{ width: "100%" }}>
                                        <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{ width: "100%" }}
                                            spacing={2}
                                        >
                                            <Grid item sx={{ flexGrow: 1 }}>
                                                <MDInput label="Message" fullWidth multiline onChange={(e) => {
                                                    setMessage(e.target.value);
                                                }} />
                                            </Grid>
                                            <Grid item>
                                                <MDButton variant="gradient" color="success" iconOnly onClick={sendMessage}>
                                                    <Icon>send</Icon>
                                                </MDButton>
                                            </Grid>
                                        </Grid>
                                    </Grid> */}
                                </Grid>
                            }
                        </Card>
                        <Card sx={{ height: "8vh", minHeight: 50, marginTop: 3, padding: 2 }}>
                            <Grid
                                container
                                height={"100%"}
                                justifyContent="center"
                                alignItems="center"
                                spacing={1}
                            >
                                <Grid item sx={{ flexGrow: 1 }}>
                                    <MDInput label="Message" fullWidth multiline
                                        value={message}
                                        onChange={(e) => {
                                            setMessage(e.target.value);
                                        }} /> {/* Ensure fullWidth prop is used */}
                                </Grid>
                                <Grid item>
                                    <MDButton variant="gradient" color="info" iconOnly
                                        disabled={(!selContact)}
                                        onClick={() => {
                                            if (selContact) {
                                                setDetailsDialog({ open: true, details: { phone: `${selContact.wa_id.slice(-10)}` } });
                                            }
                                        }}>
                                        <Icon>info</Icon>
                                    </MDButton>
                                </Grid>
                                <Grid item>
                                    <MDButton variant="gradient" color="success" iconOnly
                                        disabled={(!selContact)}
                                        onClick={sendMessage}>
                                        <Icon>send</Icon>
                                    </MDButton>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}
